const ErrorMessage = ({ message }) => {
  return (
    <div className="rounded flex flex-row bg-red-500 text-center p-2 self-center mx-auto">
      Error: {message}
    </div>
  );
};

export default ErrorMessage;
